import { render, staticRenderFns } from "./IconDashboard.vue?vue&type=template&id=049dac14"
import script from "./IconDashboard.vue?vue&type=script&lang=ts"
export * from "./IconDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports